import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TextField, Box, MenuItem } from "@mui/material";
import { useState } from "react";

import { parseValue } from "../../../../../../ui library/helpers/functions";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

// A select component that does not fetch options. It receives them via props
// and mirrors the behavior/appearance of SelectAnswer.
export function StaticSelectAnswer({
  label,
  name,
  onChange,
  value = "",
  placeholder,
  options = [], // Expected shape: [{ key, value }]
  schema,
  sx = {},
  boxMarginBottom = 4,
  allowClear = false,
}) {
  const [isFocused, setIsFocused] = useState(false);

  const type = schema?.type || schema?.[schema?.expected_input]?.properties?.[name]?.type;

  const normalizedOptions = (options || []).map(({ key, value, label }) => ({
    key,
    value: value ?? label,
  }));

  const handleChange = (e) => {
    const parsedValue = parseValue(e.target.value, type);
    onChange(name, parsedValue);
  };

  return (
    <Box mb={boxMarginBottom}>
      <QuestionTitle label={label} sx={sharedStyles.label(isFocused)} />

      <TextField
        select
        fullWidth
        size="small"
        name={name}
        value={value ?? ""}
        variant="outlined"
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        sx={{ ...sharedStyles.textField, ...sx }}
        placeholder={placeholder}
        SelectProps={{
          IconComponent: KeyboardArrowDownIcon,
          MenuProps: { PaperProps: { sx: sharedStyles.selectMenuPaper }, disablePortal: true },
        }}
      >
        <MenuItem value={null} disabled={!allowClear} sx={sharedStyles.menuItem}>
          {"-- Selection --"}
        </MenuItem>

        {normalizedOptions.map((opt, idx) => (
          <MenuItem key={`${opt.key}-${idx}`} value={opt.key} sx={sharedStyles.menuItem}>
            {opt.value}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}

export default StaticSelectAnswer;
